import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material'
import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'
import { useNavigate } from 'react-router-dom'

const reports = [
  {
    title: 'Stock Policy Adherence Report',
    description: 'View stock policy adherence against unconstrained and constrained targets.',
    route: '/reports/adherence-reports',
  },
  {
    title: 'Warehouse Inbound Forecast Report',
    description: 'View total inbound arrivals by source, work centre, destination and SKU across planning weeks.',
    route: '/reports/warehouse-inbound-report',
  },
]

export const ReportsPage = () => {
  const navigate = useNavigate()

  return (
    <Page>
      <Box display="flex" flexDirection="column" flex={1}>
        <PageHeader title="Reports" />
        <Box
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          gap={3}
          sx={{ marginTop: '16px' }}
        >
          {reports.map((report) => (
            <Card
              key={report.route}
              sx={{
                width: 300,
                border: '1px solid #e0e0e0',
                boxShadow: 'none',
                '&:hover': { boxShadow: '0 2px 8px rgba(0,0,0,0.15)' },
              }}
            >
              <CardActionArea onClick={() => navigate(report.route)} sx={{ height: '100%' }}>
                <CardContent>
                  <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <AssessmentOutlinedIcon sx={{ color: '#00415A' }} />
                    <Typography variant="subtitle1" fontWeight={600}>
                      {report.title}
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {report.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>
      </Box>
    </Page>
  )
}
